const updates = [
  { id: 1, date: '07-31', title: '香蕉视频「午夜专场」频道全新上线，限时开放中', time: '2 小时前' },
  { id: 2, date: '07-30', title: '蜜桃视频夏季热门合集已更新，新增 200+ 部精选内容', time: '昨天' },
  { id: 3, date: '07-29', title: '红桃视频高清修复专区扩容，经典港片全系列上线', time: '2 天前' },
  { id: 4, date: '07-28', title: '樱花视频综艺频道改版完成，界面更清爽、加载更快', time: '3 天前' },
  { id: 5, date: '07-27', title: '宅男视频移动端适配优化完成，手机观影体验全面升级', time: '4 天前' },
  { id: 6, date: '07-26', title: '平台安全系统全面升级，全站 HTTPS 加密更安心', time: '5 天前' },
  { id: 7, date: '07-25', title: '热门榜单算法优化，推荐精准度提升 40%', time: '6 天前' },
  { id: 8, date: '07-24', title: '香蕉视频悬疑剧场「烧脑季」专题上线，口碑炸裂', time: '7 天前' },
  { id: 9, date: '07-23', title: '蜜桃视频 × 樱花视频联合专题「夏日特供」火热上线', time: '8 天前' },
];

export default function Updates() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="section-container">
        <h2 className="section-title">最新动态</h2>
        <p className="section-subtitle">平台内容与功能更新速览，不错过每一个变化</p>
        <div className="mt-10 max-w-3xl mx-auto">
          <div className="relative">
            <div className="absolute left-[19px] top-3 bottom-3 w-px bg-background-300/60 hidden md:block"></div>
            <div className="space-y-4">
              {updates.map((item) => (
                <div key={item.id} className="flex gap-4 md:gap-6 items-start">
                  <div className="hidden md:flex w-10 h-10 rounded-full bg-accent-100 flex-shrink-0 items-center justify-center relative z-10">
                    <div className="w-2 h-2 rounded-full bg-accent-500"></div>
                  </div>
                  <div className="flex-1 min-w-0 bg-background-50 border border-background-200/70 rounded-xl p-4 md:p-5 md:ml-0">
                    <div className="flex items-center gap-3 flex-wrap mb-1">
                      <span className="text-xs font-semibold text-accent-600 bg-accent-50 px-2 py-0.5 rounded whitespace-nowrap">
                        {item.date}
                      </span>
                      <span className="text-xs text-foreground-400">{item.time}</span>
                    </div>
                    <p className="text-sm md:text-base text-foreground-800 font-medium">{item.title}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}